import { SuggestAddWidget } from "@/widgets/suggest/SuggestAddWidget";

export function SuggestAddPage() {
  return (
    <div className="page">
      <SuggestAddWidget />
    </div>
  );
}
